import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import AddInputs from "../../components/Add/AddInputs";
import S3ImageUpload from "../../components/S3uploads/S3ImageUpload";
import AddModel from "../../components/Add/AddModel";
import AddBottomButton from "../../components/Add/AddBottomButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import {
    setAddAdminFelidError,
    setIsVerifiedFirst,
} from '../AdminManagement/addAdminSlice';
import { useEffect, useState } from "react";
import {
    setInstructionText,
    setIsOpenModel,
} from "../../store/slices/modelSlice";
import useApi from "../../services/useApi";
import { showToast } from "../../components/toastMessage/toastSlice";
import endpoints from "../../services/endpoints";
import { setErrorMessage, setOtp, setOTPid } from "../auth/otpSlice";
import { setLoading } from "../auth/loginSlice";
import { inputFieldContent } from "../../components/inputfields/InputFieldContent";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { initInputToken } from "antd/es/input/style";
import ObjectBuilder from "../../components/commonfunctions/ObjectBuilder";
import deepEqual from "../../components/commonfunctions/deepEqual";
import { convertDate } from "../../components/commonfunctions/convertDate";
import { getChangedFields } from "../../components/commonfunctions/getChangedKeys";

interface CompanyDetailsType {
    company_name: string;
    contact_person_name: string;
    representative_profession: string;
    contact_email: string;
    contact_phone_number: string;
    business_type: string;
    country_code: string;
    office_no: string;
    market_block_no: string;
    floor_no: string;
    street_name: string;
    city_town: string;
    province: string;
    region: string;
    district: string;
    country: string;
    postal_code: string;
    company_license_number: string;
    company_license_expiry_date: string;
    company_tin: string;
    contract_start_date: string;
    contract_end_date: string;
    shareholder_nic_front: string;
    shareholder_nic_back: string;
    company_license_front: string;
    company_license_back: string;
    contact_phone_number_verify?: string | boolean;
    contact_email_verify?: string | boolean;
}

export default function AddCompany({ edit = false }: { edit: boolean }) {
    const initialState = {
        company_name: "",
        contact_person_name: "",
        representative_profession: "",
        contact_email: "",
        contact_phone_number: "",
        business_type: "",
        country_code: "",
        office_no: "",
        market_block_no: "",
        floor_no: "",
        street_name: "",
        city_town: "",
        province: "",
        region: "",
        district: "",
        country: "",
        postal_code: "",
        company_license_number: "",
        company_license_expiry_date: "",
        company_tin: "",
        contract_start_date: "",
        contract_end_date: "",
        shareholder_nic_front: "",
        shareholder_nic_back: "",
        company_license_front: "",
        company_license_back: "",
        contact_phone_number_verify: "false",
        contact_email_verify: "false",

    }
    const [companyDetails, setCompanyDetails] = useState<CompanyDetailsType>(initialState);
    const [errors, setErrors] = useState<Record<string, string>>({});

    const dispatch = useDispatch<AppDispatch>();

    const { otp } = useSelector((state: any) => state.otp);
    const [isOpenOtpModel, setIsOpenOtpModel] = useState(false);
    const { selectedOTPid } = useSelector((state: any) => state.model);
    const pathUrl = useSelector((state: RootState) => state.geolocation.previousUrl);
    const navigation = useNavigate();
    const [buttonloading, setButtonLoading] = useState(false);
    const { id } = useParams();
    const location = useLocation();
    const pathname = location.pathname;
    const { otpVerify, otpSend } = endpoints;
    const { PostAPI, PatchAPI, getAPI } = useApi();
    const { translate, replace } = useTranslation(inputFieldContent);
    const [editLoading, setEditLoading] = useState(false);
    const [tempDetails, setTempDetails] = useState(initialState);
    const [lastVerfication, setLastVerfication] = useState({
        contact_email: '',
        contact_phone_number: '',
    })
    const [verifyLoaders, setVerifyLoaders] = useState({
        contact_email: false,
        contact_phone_number: false,
    })

    const inputs = {
        "Basic Details": {
            "Company Name": {
                required: true,
                disabled: false,
                id: "company_name",
                maxLength: 60,
                type: "input",
                tabIndex: 0,
                testId: "company_management_company_name",
            },
            "Contact Person/Representative Name": {
                required: true,
                disabled: false,
                maxLength: 60,
                id: "contact_person_name",
                type: "input",
                tabIndex: 1,
            },
            "Representative Profession": {
                required: true,
                disabled: false,
                maxLength: 60,
                id: "representative_profession",
                type: "input",
                tabIndex: 1,
            },
            "Contact Email Address": {
                required: true,
                disabled: !companyDetails?.company_name,
                id: "contact_email",
                maxLength: 90,
                type: "input_verification",
                tabIndex: 2,
                validation: false,
            },
            "Contact Phone Number": {
                required: true,
                disabled: !companyDetails?.company_name,
                id: "contact_phone_number",
                type: "phone_number",
                maxLength: 15,
                tabIndex: 3,
            },
            'Business Type': {
                id: "business_type",
                type: "dropDown",
                required: true,
                disabled: false,
                noSearch: true,
                options: [
                    "Super store",
                    "Retail Store",
                    "Wholesales Store",
                    "Handseller",
                    "Logistic company",
                    "Services company",
                    "Distribution company",
                    "Transportation company",
                    "Payment service provider",
                    "Exchange Services",
                    "Petrol pump stations",
                    "Restaurants",
                    "Pharmacies",
                    "Convenience stores",
                    "Mobile (on the go) agent",
                    "FMCGs companies"
                ]
                ,
                tabIndex: 5,
            },
        },
        "Company Residential Details": {
            "Office No.": {
                required: false,
                disabled: false,
                id: "office_no",
                type: "input",
                maxLength: 60,
                tabIndex: 4,
            },
            "Market/Block No.": {
                required: false,
                disabled: false,
                id: "market_block_no",
                type: "input",
                maxLength: 60,
                tabIndex: 5,
            },
            "Floor No.": {
                required: false,
                disabled: false,
                id: "floor_no",
                type: "input",
                tabIndex: 6,
                maxLength: 60,
            },
            "Street Name": {
                required: false,
                disabled: false,
                id: "street_name",
                type: "input",
                tabIndex: 7,
            },
            Country: {
                required: false,
                disabled: false,
                id: "country",
                type: "country_type",
                tabIndex: 9,
            },
        },
        "Company Details": {
            "Company License No.": {
                required: true,
                disabled: false,
                id: "company_license_number",
                maxLength: 60,
                type: "input",
                tabIndex: 0,
            },
            "Company License Expiry Date": {
                required: true,
                disabled: false,
                maxLength: 60,
                id: "company_license_expiry_date",
                type: "date",
                tabIndex: 1,
                disabledPastDate: true // Disable past dates
            },
            "Company TIN": {
                required: true,
                disabled: false,
                id: "company_tin",
                maxLength: 90,
                type: "input",
                tabIndex: 2,
            },
            "Contract Start Date": {
                required: true,
                disabled: false,
                maxLength: 60,
                id: "contract_start_date",
                type: "date",
                tabIndex: 1,
            },
            "Contract End Date": {
                required: true,
                disabled: false,
                maxLength: 60,
                id: "contract_end_date",
                type: "date",
                tabIndex: 1,
                disabledPastDate: true // Disable past dates
            }
        },
    };

    const fileUploadsObject = [
        {
            name: 'Share Holder NIC Front Page',
            id: 'shareholder_nic_front',
        },
        {
            name: 'Share Holder NIC Back Page',
            id: 'shareholder_nic_back',
        },
        {
            name: 'Company License Front Page',
            id: 'company_license_front',
        },
        {
            name: 'Company License Back Page',
            id: 'company_license_back',
        },
    ]


    const handleInputValues = (key: string, value: string) => {

        // Check if the input field is 'first_name' or 'last_name'
        if (key === 'contact_person_name') {
            // If it's 'first_name' or 'last_name', update the corresponding state
            const regex = /^[A-Za-z\s]*$/;
            // If the value contains numbers and special characters, stop execution and return
            if (!regex.test(value)) {
                return;
            }
        }
        switch (key) {
            case "contact_phone_number":
                // dispatch(
                //     setUpdateAdminStates({ key: "phone_number_verify", value: id ? (editData.phone_number === value && isVerifiedFirst) ? 'true' : "" : "" })
                // );
                if (value !== "" && value === lastVerfication?.[key]) {
                    setCompanyDetails((prev) => ({
                        ...prev,
                        'contact_phone_number_verify': 'true',
                    }))
                } else {
                    setCompanyDetails((prev) => ({
                        ...prev,
                        'contact_phone_number_verify': '',
                    }))
                }
                break;
            case "contact_email":
                if (value !== '' && value === lastVerfication?.[key]) {
                    setCompanyDetails((prev) => ({
                        ...prev,
                        'contact_email_verify': 'true',
                    }))
                } else {
                    setCompanyDetails((prev) => ({
                        ...prev,
                        'contact_email_verify': '',
                    }))
                }
                break;
            default:
                break;
        }
        setErrors((prev) => (
            {
                ...prev,
                [key]: '',
            }
        ))
        setCompanyDetails((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const handleSubmit = async () => {
        // Reset errors
        setErrors({})
        // Array of mandatory fields
        const mandatoryFields = [
            'company_name',
            'contact_person_name',
            'representative_profession',
            'business_type',
            'contact_email',
            'contact_phone_number',
            'country_code',
            ...(tempDetails.country === 'Afghanistan' ? ['city_town', 'district'] : []),
            'province',
            'region',
            'postal_code',
            'country',
            'company_license_number',
            'company_license_expiry_date',
            'company_tin',
            'contract_start_date',
            'contract_end_date',
            'shareholder_nic_front',
            'shareholder_nic_back',
            'company_license_front',
            'company_license_back',
        ];

        // Temporary object to store all errors
        const fieldErrors: Record<string, string> = {};

        // Validate mandatory fields
        mandatoryFields.forEach(field => {
            if (!companyDetails[field as keyof CompanyDetailsType]) {
                fieldErrors[field] = "This field is required";
            }
        });

        // // Validate email format
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (companyDetails.contact_email && !emailRegex.test(companyDetails.contact_email)) {
        //     fieldErrors.contact_email = "Invalid email format";
        // }

        // // Validate phone number format
        // if (companyDetails.contact_phone_number && !/^\d{10,15}$/.test(companyDetails.contact_phone_number)) {
        //     fieldErrors.contact_phone_number = "Invalid phone number format";
        // }

        // Validate dates
        if (companyDetails.contract_start_date && companyDetails.contract_end_date) {
            const startDate = new Date(companyDetails.contract_start_date);
            const endDate = new Date(companyDetails.contract_end_date);

            if (startDate > endDate) {
                fieldErrors.contract_end_date = "End date must be greater than start date";
            }
        }

        // Validate email verification
        if (companyDetails.contact_email_verify !== true && companyDetails.contact_email_verify !== 'true') {
            fieldErrors.contact_email = "Please verify the email address";
        }

        // Validate phone number verification
        if (companyDetails.contact_phone_number_verify !== true && companyDetails.contact_phone_number_verify !== 'true') {
            fieldErrors.contact_phone_number = "Please verify the phone number";
        }

        // Only set errors if there are any
        if (Object.keys(fieldErrors).length > 0) {
            setErrors(fieldErrors);
            return;
        }

        // Create payload
        const { contact_phone_number_verify, contact_email_verify, ...apiPayload } = companyDetails;

        // Format phone number and country code
        if (apiPayload.contact_phone_number && apiPayload.country_code) {
            if (apiPayload.contact_phone_number.startsWith(apiPayload.country_code)) {
                apiPayload.contact_phone_number = apiPayload.contact_phone_number.slice(apiPayload.country_code.length);
            }
            apiPayload.country_code = `+${apiPayload.country_code}`;
        }

        try {
            // Show loading state if you have one
            // dispatch(setAddLoading(true));
            // Make API call
            setButtonLoading(true);
            let response;
            if (id) {
                let updatePayload = getChangedFields(tempDetails, companyDetails);
                delete updatePayload?.contact_phone_number_verify;
                delete updatePayload?.contact_email_verify;
                response = await PatchAPI(`companies/${id}`, updatePayload);
            } else {
                response = await PostAPI('companies', apiPayload);
            }

            if (!response.error) {
                navigation('/company-management');
                dispatch(showToast({
                    message: response.data.message,
                    type: "success"
                }));

            } else {
                dispatch(showToast({
                    message: response.data.response.data.message,
                    type: "error"
                }));
            }
        } catch (error: any) {
            // Handle unexpected errors
            dispatch(showToast({
                message: error.message || "An unexpected error occurred",
                type: "error"
            }));
        } finally {
            setButtonLoading(false);
        }
    };
    const handleSubmitOTP = async () => {
        dispatch(setLoading(true));
        const payload =
            selectedOTPid === "contact_phone_number"
                ? {
                    phone_number: `+${companyDetails?.contact_phone_number}`,
                    otp: otp.join(""),
                }
                : {
                    email_address: companyDetails?.contact_email,
                    otp: otp.join(""),
                };

        try {
            const res = await PostAPI(otpVerify, payload);
            if (!res.error) {
                handleInputValues(
                    selectedOTPid === "contact_phone_number"
                        ? "contact_phone_number_verify"
                        : "contact_email_verify",
                    "true" // Assuming value should be "true"
                );
                setLastVerfication((prev) => ({
                    ...prev,
                    [selectedOTPid]: selectedOTPid === "contact_phone_number" ? companyDetails?.contact_phone_number : companyDetails?.contact_email
                }))
                setIsOpenOtpModel(false)
                dispatch(setOtp({ otp: [] }));
                dispatch(setIsVerifiedFirst(false))
                setErrors((prev) => ({
                    ...prev,
                    [selectedOTPid]: '',
                }))
            } else {
                dispatch(setErrorMessage(res.data.response.data.message || "Invalid OTP."));
            }
        } catch (error: any) {
            console.error("Error verifying OTP:", error);
            dispatch(setErrorMessage("Invalid OTP. Please try again."));
        } finally {
            dispatch(setLoading(false));
        }
    };
    const handleVerify = async (id: string, resend: boolean) => {
        dispatch(setOTPid(id));
        const errors: Record<string, string> = {};
        if (id === "contact_phone_number") errors.contact_phone_number = "";
        if (id === "contact_email") errors.contact_email = "";
        try {
            const payload =
                id === "contact_phone_number"
                    ? {
                        phone_number: `+${companyDetails?.contact_phone_number}`,
                        name: companyDetails?.company_name,
                        user_type: "Company",
                    }
                    : {
                        email_address: `${companyDetails.contact_email}`,
                        name: companyDetails?.company_name,
                        user_type: "Company",
                    };
            setVerifyLoaders((prev) => ({
                ...prev,
                [id]: true,
            }));
            const response = await PostAPI(otpSend, payload);
            if (!response.error) {
                setIsOpenOtpModel(true);
                dispatch(
                    showToast({
                        type: "info",
                        message: resend
                            ? "OTP resent"
                            : replace(`OTP has been sent to {{phone_or_email}}`, {
                                phone_or_email:
                                    id === "contact_phone_number" ? `+${companyDetails?.contact_phone_number.replace(companyDetails?.country_code, `${companyDetails?.country_code} `)}` : companyDetails.contact_email
                                ,
                            }),
                    })
                );
                dispatch(setIsOpenModel(true));
                dispatch(
                    setInstructionText({
                        text: replace(`We have sent a code to {{phone_or_email}}`, {
                            phone_or_email:
                                id === "contact_phone_number" ? `+${companyDetails?.contact_phone_number.replace(companyDetails?.country_code, `${companyDetails?.country_code} `)}` : companyDetails?.contact_email,
                        }),
                        id,
                    })
                );
            } else {
                dispatch(setAddAdminFelidError(id));
                dispatch(
                    showToast({
                        type: "error",
                        message: response?.data?.response?.data?.message,
                    })
                );
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            dispatch(
                showToast({
                    type: "error",
                    message: "Failed to send OTP. Please try again.",
                })
            );
        } finally {
            setVerifyLoaders((prev) => ({
                ...prev,
                [id]: false,
            }));
        }
    };

    const fetchCompanyDetails = async () => {
        try {
            setEditLoading(true);
            let response = await getAPI(`companies/${id}`);
            if (!response.error) {
                let object = ObjectBuilder(initialState, response.data.data);
                object = {
                    ...object,
                    contact_phone_number: object.contact_phone_number,
                    contact_phone_number_verify: "true",
                    contact_email_verify: "true",
                    company_license_expiry_date: convertDate(object.company_license_expiry_date),
                    contract_start_date: convertDate(object.contract_start_date),
                    contract_end_date: convertDate(object.contract_end_date)
                }
                setCompanyDetails(object);
                setTempDetails(object);
                setLastVerfication({
                    contact_phone_number: object?.contact_phone_number || "",
                    contact_email: object?.contact_email || ''
                })
            } else {
                dispatch(showToast({
                    message: response.data.response.data.message,
                    type: "error"
                }));
            }
        } catch (error) {
            console.error("Error fetching company details:", error);
        } finally {
            setEditLoading(false);
        }
    }
    useEffect(() => {
        if (id) {
            fetchCompanyDetails();
        }
    }, []);
    return (
        <div className="">
            <Breadcrumbs
                navPath={[
                    "Company Management",
                    "List of Companies",
                    ...(pathname.includes("view-company") ? ["View Company Details"] : []),
                    `${id ? "Edit" : "Add"} Company`,
                ]}
                heading={`${id ? "Edit" : "Add"} Company`}
                links={[
                    "/company-management",
                    "/company-management",
                    id ? `/company-management/view-company/${id}` : "",
                ]}
            />
            <AddModel>
                <AddInputs
                    editLoading={editLoading}
                    inputs={inputs}
                    totalInputCount={7}
                    verifyLoaders={verifyLoaders}
                    onInputChange={handleInputValues}
                    inputValues={companyDetails || {}}
                    handleVerify={handleVerify}
                    errors={errors}
                    handleSubmitOTP={handleSubmitOTP}
                    isDisabledField={id ? ['email_address'] : []}
                    isOpenOtpModel={isOpenOtpModel}
                    setIsOpenOtpModel={setIsOpenOtpModel}
                    RequiredPostalCode={true}
                    mapping={true}
                />
                <div className="flex flex-col gap-4">
                    {[0, 1].map((rowIndex) => (
                        <div className="flex flex-col sm:flex-row gap-6" key={rowIndex}>
                            {fileUploadsObject.slice(rowIndex * 2, rowIndex * 2 + 2).map((item, index) => (
                                <S3ImageUpload
                                    key={index + rowIndex * 2}
                                    label={item.name}
                                    required={true}
                                    heading=""
                                    disabled={false}
                                    upload_id={item.id}
                                    UploadPath={"uploads/admins/company-management"}
                                    handleUpload={handleInputValues}
                                    uploadedFile={String(companyDetails?.[item.id as keyof typeof companyDetails] || '')}
                                    errorMessage={errors[item?.id]}
                                    uploadedContainerClass="w-full sm:w-[410px]"
                                />
                            ))}
                        </div>
                    ))}
                </div>

            </AddModel>
            <AddBottomButton
                buttonName={`${!id ? 'Add' : 'Update'} Company`}
                buttonClass="w-[120px]"
                buttonWidth={`${!id ? 'w-[140px]' : 'w-[170px]'}`}
                onClick={handleSubmit}
                disabled={id && deepEqual(companyDetails, tempDetails)}
                loading={buttonloading}
                testID={"add_admin_page"}
            />
        </div>
    );
}

